export const API_STAGEWISE_UNCONVERTED_LEADS_SUCCESS =
  "API_STAGEWISE_UNCONVERTED_LEADS_SUCCESS";
export const API_STAGEWISE_UNCONVERTED_LEADS_FAIL =
  "API_STAGEWISE_UNCONVERTED_LEADS_FAIL";
export const GET_STAGEWISE_UNCONVERTED_LEADS =
  "GET_STAGEWISE_UNCONVERTED_LEADS";

export const STAGEWISE_STEPS_DATA = "STAGEWISE_STEPS_DATA";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";